/* global google */
var _ = require('underscore');
var GMapsLayerView = require('./gmaps-layer-view');

var GMapsTiledLayerView = function (layerModel, opts) {
  GMapsLayerView.apply(this, arguments);
  this.tileSize = new google.maps.Size(256, 256);
  this.opacity = 1.0;
  this.isPng = true;
  this.maxZoom = 22;
  this.minZoom = 0;
  this.name = 'cartodb tiled layer';
  google.maps.ImageMapType.call(this, this);
};

_.extend(
  GMapsTiledLayerView.prototype,
  GMapsLayerView.prototype,
  google.maps.ImageMapType.prototype, {

    getTileUrl: function (tile, zoom) {
      var y = tile.y;
      var tileRange = 1 << zoom;
      if (y < 0 || y >= tileRange) {
        return null;
      }
      var x = tile.x;
      if (x < 0 || x >= tileRange) {
        x = (x % tileRange + tileRange) % tileRange;
      }
      if (this.model.get('tms')) {
        y = tileRange - y - 1;
      }
      var urlPattern = this.model.get('urlTemplate');
      return urlPattern
        .replace('{x}', x)
        .replace('{y}', y)
        .replace('{z}', zoom);
    }
  });

module.exports = GMapsTiledLayerView;



//////////////////
// WEBPACK FOOTER
// ./~/cartodb.js/src/geo/gmaps/gmaps-tiled-layer-view.js
// module id = 1632
// module chunks = 6